import * as React from 'react';
import { styles } from './styles';
import { BaseButton } from '@routes/event/create/components/BaseButton';

interface Props {
  message: string;
  id?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const MoreOptionsMessage: React.SFC<Props> = ({ message, id, onClick }) => {
  return (
    <div className={styles.container}>
      <p className={styles.message}>{message}</p>
      {onClick && (
        <BaseButton id={id} className={styles.button} onClick={onClick}>
          Start With This Design
        </BaseButton>
      )}
    </div>
  );
};
